module.exports = __webpack_public_path__ + "img/05.904a0655.png";